import { restRequestMultiple } from 'common-src/features/rest/actions';
import { syncDashboardV2Appointments } from 'common-src/models/DashboardV2Appointment/sync';
import { syncDashboardV2TaskQueue } from 'common-src/models/DashboardV2Task/sync';
import { getPatientIntegrationsAthenaRequest } from 'common-src/models/PatientIntegrationsAthena';

import {
  setCareOrchestrationLastFetchedAt,
  setCareOrchestrationMeta,
  setCareOrchestrationStats,
} from 'src/features/careOrchestration';

import { getAppointmentPatientId, getTaskPatientId } from '../helpers';

export const syncCareOrchestrationData = ({
  dispatch,
  taskQueueRows,
  taskQueueMeta,
  appointmentsBody,
  statsBody,
}) => {
  syncDashboardV2TaskQueue({
    data: taskQueueRows,
    meta: taskQueueMeta,
  });
  syncDashboardV2Appointments(appointmentsBody);

  const integrationPatientIds = new Set();

  (appointmentsBody?.data || []).forEach((appointment) => {
    const patientId = getAppointmentPatientId(appointment);
    if (patientId != null) integrationPatientIds.add(patientId);
  });

  taskQueueRows.forEach((task) => {
    const patientId = getTaskPatientId(task);
    if (patientId != null) integrationPatientIds.add(patientId);
  });

  if (integrationPatientIds.size) {
    dispatch(
      restRequestMultiple({
        restRequests: Array.from(integrationPatientIds).map((patientId) =>
          getPatientIntegrationsAthenaRequest({ patientId }),
        ),
      }),
    );
  }

  dispatch(setCareOrchestrationStats(statsBody?.data || null));
  dispatch(
    setCareOrchestrationMeta({
      tasks: taskQueueMeta || null,
      appointments: appointmentsBody?.meta || null,
      stats: statsBody?.meta || null,
      readiness: null,
    }),
  );
  dispatch(setCareOrchestrationLastFetchedAt(new Date().toISOString()));
};
